import { Reveal, Eyebrow } from "../site/Reveal";
import { TRUST } from "../../lib/content";

export const TrustSection = () => (
  <section data-testid="trust-section" className="bg-paper py-24 sm:py-32">
    <div className="container-x grid gap-14 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <Eyebrow>A nossa abordagem</Eyebrow>
          <Reveal><h2 className="mt-5 font-display text-4xl font-semibold leading-[0.95] tracking-tight text-forest sm:text-5xl">Uma solução solar pensada para as suas necessidades</h2></Reveal>
          <Reveal delay={0.1} className="mt-10">
            <img src="/images/tecnico.jpg" alt="Técnico com equipamento de segurança a instalar um painel solar numa cobertura" loading="lazy" className="aspect-[4/3] w-full rounded-[2rem] object-cover [clip-path:polygon(0_0,100%_8%,100%_100%,0_100%)]" />
          </Reveal>
        </div>
      </div>
      <div className="lg:col-span-7 lg:pt-24">
        {TRUST.map((t, i) => (
          <Reveal key={t.title} delay={i * 0.05}>
            <div data-testid={`trust-item-${i}`} className="group grid gap-4 border-t border-forest/15 py-10 sm:grid-cols-[110px_1fr]">
              <span className="font-display text-5xl font-semibold tracking-tighter text-solar-ink transition-transform duration-500 group-hover:-translate-y-1">0{i + 1}</span>
              <div>
                <h3 className="font-display text-2xl font-medium tracking-tight text-forest sm:text-3xl">{t.title}</h3>
                <p className="mt-3 max-w-xl text-[15px] leading-relaxed text-ink/75 sm:text-base">{t.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
